import { categories } from "@/mocks/siteData";
import { Link, useLocation } from "react-router-dom";

interface CategoryTabsProps {
  activeCategory?: string;
}

export default function CategoryTabs({ activeCategory }: CategoryTabsProps) {
  const location = useLocation();

  return (
    <div className="flex flex-wrap gap-2">
      <Link
        to="/"
        className={`px-4 py-2 text-sm rounded-full transition-all duration-200 whitespace-nowrap ${
          location.pathname === "/"
            ? "bg-accent-500 text-background-50"
            : "bg-background-100 text-foreground-700 hover:bg-background-200"
        }`}
      >
        全部文章
      </Link>
      {categories.map((cat) => (
        <Link
          key={cat.id}
          to={`/category/${cat.slug}`}
          className={`px-4 py-2 text-sm rounded-full transition-all duration-200 whitespace-nowrap ${
            activeCategory === cat.id
              ? "bg-accent-500 text-background-50"
              : "bg-background-100 text-foreground-700 hover:bg-background-200"
          }`}
        >
          {cat.name}
        </Link>
      ))}
    </div>
  );
}